import { FormGroup, InputGroup } from '@blueprintjs/core'
import classNames from 'classnames'
import React, { SFC, SyntheticEvent } from 'react'

import { isPresent } from '../../app/shared'
import { SyncIndicator } from './sync-indicator'
import { FieldAdapterProps, TextInputProps } from './types'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

export type Props = FieldAdapterProps<TextInputProps>

const TextInputAdapter: SFC<Props> = ({
  input,
  meta,
  placeholder,
  type,
  helperText,
  disabled = false,
  inline,
  required,
  intent,
  label,
  autoFocus = false,
  enableSyncControl,
  prefixText,
  suffixText,
  translate = identity,
  // tslint:disable-next-line:no-empty
  onSyncChange = (fieldName: string, newValue: boolean) => {},
  regEx,
}) => {
  const { id, labelText } = createLabelWithId(input, label)
  const intentType = getIntent(meta, intent)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)

  // TODO: Needs to be refactored => change to trigger for validate after sync change
  const handleSyncChange = (fieldName: string, newValue: boolean) => {
    onSyncChange(fieldName, newValue)
    const value = input.value
    input.onChange(' ') // trigger for validate
    window.setTimeout(() => input.onChange(value))
  }

  const reqLabelMod = (
    <>
      {labelInfo}
      {enableSyncControl && (
        <SyncIndicator
          translate={translate}
          fieldName={input.name}
          disabled={disabled}
          onSyncChange={handleSyncChange}
        />
      )}
    </>
  )

  const formGroupClassName = classNames({
    required: isPresent(labelInfo),
    'has-prefix-text': isPresent(prefixText),
    'has-suffix-text': isPresent(suffixText),
  })

  return (
    <FormGroup
      className={formGroupClassName}
      helperText={helperTextMessage}
      label={isPresent(prefixText) ? undefined : labelText}
      labelFor={id}
      labelInfo={reqLabelMod}
      intent={intentType}
      inline={inline}
      disabled={disabled}
    >
      {prefixText && <div className="bp3-input-prefix">{prefixText}</div>}
      <InputGroup
        id={id}
        {...input}
        onChange={onChangeWithRegexp(input.onChange, regEx)}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        intent={intentType}
        autoFocus={autoFocus}
      />
      {suffixText && <div className="bp3-input-suffix">{suffixText}</div>}
    </FormGroup>
  )
}

// this would be good to move to utils.ts if it will be used on other adapters/places
const onChangeWithRegexp = (originalOnChange: (e: SyntheticEvent<HTMLInputElement>) => void, regEx?: RegExp) => (
  e: SyntheticEvent<HTMLInputElement>
) => {
  if (regEx === undefined || regEx.test(e.currentTarget.value)) {
    originalOnChange(e)
  }
}

export { TextInputAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/text-input-adapter.tsx